"use strict";

var _objectWithoutProperties = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = AuthButton;

var _react = _interopRequireDefault(require("react"));

var _LoginButton = _interopRequireDefault(require("./LoginButton"));

var _LogoutButton = _interopRequireDefault(require("./LogoutButton"));

var _useLoggedIn = _interopRequireDefault(require("../hooks/useLoggedIn"));
/** Button that lets the user log in or out with Solid.  */


function AuthButton(_ref) {
  var login = _ref.login,
      logout = _ref.logout,
      props = _objectWithoutProperties(_ref, ["login", "logout"]);

  return (0, _useLoggedIn.default)() ? _react.default.createElement(_LogoutButton.default, props, logout) : _react.default.createElement(_LoginButton.default, props, login);
}